import React from "react";
import { StyleSheet, View } from "react-native";

import { spacing } from "../../styles";
import Avatar from "../Avatar";
import Typography from "../Typography";

type Props = {
  avatarUrl: string;
  title: string;
  body: string;
};

const TitleBodyContent = ({ avatarUrl, title, body }: Props) => (
  <View style={styles.container}>
    <View style={styles.avatarContainer}>
      <Avatar uri={avatarUrl} />
    </View>

    <View style={styles.contentContainer}>
      <Typography variant="bodyBold">{title}</Typography>
      <Typography variant="body">{body}</Typography>
    </View>
  </View>
);

export default React.memo(TitleBodyContent);

const styles = StyleSheet.create({
  avatarContainer: {
    flex: 1,
  },
  container: {
    flex: 1,
    flexDirection: "row",
    padding: spacing.unit * 2,
  },
  contentContainer: {
    flex: 4,
  },
});
